import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import PDPCustomerPhotosGridUI from './PDPCustomerPhotosGridUI';
const PDPCustomerPhotosGrid = t0 => {
  const $ = _c(4);
  const {
    photos,
    totalPhotos,
    onPhotoClick
  } = t0;
  let t1;
  if ($[0] !== onPhotoClick || $[1] !== photos || $[2] !== totalPhotos) {
    t1 = <PDPCustomerPhotosGridUI photos={photos} totalPhotos={totalPhotos} onPhotoClick={onPhotoClick} />;
    $[0] = onPhotoClick;
    $[1] = photos;
    $[2] = totalPhotos;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};
PDPCustomerPhotosGrid.propTypes = {
  photos: PropTypes.array,
  totalPhotos: PropTypes.number,
  onPhotoClick: PropTypes.func
};
export default PDPCustomerPhotosGrid;